import { Grid } from 'packages/smart-home-support/components';
import { PartnerContent } from 'packages/smart-home-support/partner';
import React from 'react';
import styled from 'styled-components';
import { useUser } from '../../../../hooks';
import { useDevices } from '../../hooks';
import { Heading2, TabContent } from '../../styles';
import { default as DeviceComponent } from './Device';

const s = {
  Heading2,
  TabContent,
  Intro: styled.div`
    font-size: 20px;
    line-height: 1.5;
  `,
  Summary: styled.div`
    font-weight: bold;
    font-size: 16px;
    margin-top: 27px;
    margin-bottom: 17px;
  `,
  DeviceGrid: styled(Grid)`
    margin-left: -8px;
    margin-right: -8px;
    margin-top: -8px;
  `,
  DeviceWrapper: styled.div`
    margin: 9px;
  `,
};

const DevicesTab = () => {
  const user = useUser();
  const [devices] = useDevices(user);

  return (
    <s.TabContent>
      <s.Intro>
        {devices ? (
          devices.length ? (
            <>Select any device to start a claim or get help.</>
          ) : (
            <PartnerContent Sprint="Keep track of your devices by adding them to your account.">
              How much tech is in your home? Let&rsquo;s make your list!
            </PartnerContent>
          )
        ) : (
          <>Loading...</>
        )}
      </s.Intro>
      <s.Summary>{devices ? <>{devices.length} devices</> : <>&nbsp;</>}</s.Summary>
      <s.DeviceGrid
        minLength={10}
        items={[
          <s.DeviceWrapper>
            <DeviceComponent />
          </s.DeviceWrapper>,
          ...(devices || []).map((device, i) => (
            <s.DeviceWrapper key={i}>
              <DeviceComponent device={device} />
            </s.DeviceWrapper>
          )),
        ]}
      />
    </s.TabContent>
  );
};

export default DevicesTab;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/DevicesTab/DevicesTab.tsx